import { localStorage } from 'dash-ui';

export function downloadMedia(mediaIds: string[]): void {
  window.open(
    process.env['REACT_APP_REST'] +
      `/media/download?accessToken=${localStorage.getAccessToken()}&mediaIds=${JSON.stringify(
        mediaIds
      )}`,
    '_self'
  );
}

export function downloadAllMediaInProperty(propertyId: string): void {
  window.open(
    process.env['REACT_APP_REST'] +
      `/media/download-all-media-in-property?accessToken=${localStorage.getAccessToken()}&propertyId=${propertyId}`,
    '_self'
  );
}

export function downloadDocumentFile(file: {
  publicUrl: string;
  name: string;
}): void {
  const link = document.createElement('a');
  link.href = file.publicUrl;
  link.setAttribute('download', file.name);
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
